import { Manager } from './type'

export const getLookupValue = (
    lookupValues: any[],
    type: string,
    id: number
): string => {
    const lookup = lookupValues?.find(
        (item: any) =>
            item.lookUpType?.toLowerCase() === type?.toLowerCase() &&
            item.id === id
    )
    return lookup ? lookup?.lookUpValue : ''
}

export const getLocationNameById = (locations: any[], id: string) => {
    const location = locations?.find((location) => location.id === id)
    return location ? location.name : ''
}

export const getOptions = (lookupValues: any[], type: string) => {
    return lookupValues
        ?.filter((item) => item?.lookUpType === type)
        ?.map((item) => ({
            value: item.id.toString(),
            label: item.lookUpValue,
        }))
}

export const getLocationOptions = (lookupValues: any[]) => {
    return lookupValues
        ?.filter((item) => item.name)
        ?.map((item) => ({
            value: item.id.toString(),
            label: item.name,
        }))
}

export const findManagerById = (
    managers: Manager[],
    id: string | null
): string | null => {
    if (!id) return null
    const manager = managers.find((manager) => manager.id === id)
    return manager ? `${manager.firstName} ${manager.lastName}` : ''
}

export const formatDateOfBirth = (date: string): string | null => {
    const [month, day, year] = date.split('/').map(Number)

    // Check if the date components are valid numbers
    if (isNaN(month) || isNaN(day) || isNaN(year)) {
        console.error('Invalid date components')
        return null
    }

    // Create a new Date object
    const parsedDate = new Date(year, month - 1, day)

    // Check if the Date object is valid
    if (isNaN(parsedDate.getTime())) {
        console.error('Invalid date')
        return null
    }

    return parsedDate.toISOString()
}
